module.exports = __webpack_public_path__ + "img/00_CAGUAMON.e995cdbf.png";